import { getTripleID } from "./common"
export const trackFooterClick = name => {
  if (window?.dataLayer) {
    window.dataLayer.push({
      event: "footer_click",
      button_name: name,
      ...getTripleID()
    })
  }
}
